import * as PIXI from 'pixi.js';

import fragment from './fragment.frag';


class ColorChannelMapPixiFilter extends PIXI.Filter {
    constructor() {
        super(PIXI.defaultFilterVertex, fragment);
        this.uniforms.redChannelTargetColor = new Float32Array([1, 0, 0]);
        this.uniforms.greenChannelTargetColor = new Float32Array([0, 1, 0]);
        this.uniforms.blueChannelTargetColor = new Float32Array([0, 0, 1]);
        this.uniforms.isRedChannelMappedToAlpha = false;
        this.uniforms.isGreenChannelMappedToAlpha = false;
        this.uniforms.isBlueChannelMappedToAlpha = false;
    }
}

export { ColorChannelMapPixiFilter };
